import React from 'react';
import PropTypes from 'prop-types';
import {Form} from "formik";
import FormTitle from "../../../Inspection/components/FormTitle";
import FieldInput from "../../../../common/components/FieldInput";
import FieldSelect from "../../../../common/components/FieldSelect";
import FieldDatepicker from "../../../../common/components/FieldDatepicker";
import FieldCheckbox from "../../../../common/components/FieldCheckbox";
import FieldFindCustomers from "../../../../common/components/FieldFindCustomers";
import ButtonCommon from "../../../../common/components/ButtonCommon";
import {
  limitIntegerValueLength,
  limitValueRangeFloat,
  divideThousandsInteger,
  formatStringToNumber,
  floatValue
} from "../../../../common/utils/form/limitValueLength";
import {SectionFiles} from "../SectionFiles/components/SectionFiles";
import {InspectionOtherFilesProvider} from "../InspectionOtherFilesContext";
import classnames from 'classnames';
import styles from './styles.module.scss';


const InspectionOtherFormView = ({
                                   orderID,
                                   shumaID,
                                   firmShumaID,
                                   formik,
                                   options,
                                   cityChangeProps,
                                   handleDataSubmit
                                 }) => {

  return (
    <div className={styles.inspectionOtherFormContainer}>
      <Form>
        <FormTitle title={`עריכת דוח - ${firmShumaID}`} className={styles.header}/>
        <div className={styles.unit}>
          <div className={styles.subheader}>מידע כללי</div>
          <div className={classnames(styles.flexBetween, styles.threeQuartersRow, styles.marginBottom25)}>
            <FieldInput
              fieldId={'gush'}
              value={formik.values.gush}
              onChange={limitIntegerValueLength(5)}
              label={'גוש'}
              containerCustomStyles={styles.quarterField}
            />
            <FieldInput
              fieldId={'helka'}
              value={formik.values.helka}
              onChange={limitIntegerValueLength(4)}
              label={'חלקה'}
              containerCustomStyles={styles.quarterField}
            />
            <FieldInput
              fieldId={'ttHelka'}
              value={formik.values.ttHelka}
              onChange={limitIntegerValueLength(3)}
              label={'תת חלקה'}
              containerCustomStyles={styles.quarterField}
            />
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
            <FieldSelect
              fieldId={'cityID'}
              value={formik.values.cityID}
              placeholder="עיר"
              label={'עיר'}
              options={options?.cities}
              isSearchable={true}
              isAsync={true}
              containerStyles={styles.halfField}
              {...cityChangeProps}
            />
            <FieldSelect
              fieldId={'streetID'}
              value={formik.values.streetID}
              placeholder="רחוב"
              label={'רחוב'}
              options={options.streets}
              isSearchable={true}
              isAsync={true}
              defaultOptions={true}
              disabled={!formik.values.cityID}
              containerStyles={styles.halfField}
            />
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
            <FieldInput
              fieldId={'houseNumber'}
              value={formik.values.houseNumber}
              label={'מספר בית'}
              containerCustomStyles={styles.halfField}
            />
            <FieldDatepicker
              fieldId={'officialDate'}
              label={'המועד הקובע לדו"ח'}
              containerStyles={styles.halfField}
            />
          </div>
          <div className={classnames(styles.flexBetween, styles.marginBottom25)}>
            <FieldInput
              fieldId={'averageSqmPrice'}
              label={'מחיר למ"ר'}
              onChange={floatValue}
              containerCustomStyles={styles.halfField}
            />
            <FieldInput
              fieldId={'estimatePriceFinal'}
              label={'הערכת שווי הנכס'}
              value={divideThousandsInteger(formik.values.estimatePriceFinal)}
              onChange={formatStringToNumber}
              containerCustomStyles={styles.halfField}
            />
          </div>
        </div>
        <div className={styles.unit}>
          <div className={styles.subheader}>מידע על הנכס</div>
          <div className={classnames(styles.flexBetween, styles.threeQuartersRow, styles.marginBottom25)}>
            <FieldInput
              fieldId={'landRegisteredLotArea'}
              label={'שטח מגרש'}
              containerCustomStyles={styles.quarterField}
            />
            <FieldInput
              fieldId={'houseRegisteredArea'}
              label={'שטח רשום'}
              containerCustomStyles={styles.quarterField}
            />
            <FieldInput
              fieldId={'houseRoomCount'}
              label={'מספר חדרים'}
              onChange={limitValueRangeFloat(4, 0, 99.9)}
              containerCustomStyles={styles.quarterField}
            />
          </div>
          <div className={classnames(styles.flexBetween, styles.threeQuartersRow, styles.marginBottom25)}>
            <FieldInput
              fieldId={'floor'}
              label={'קומה'}
              containerCustomStyles={styles.quarterField}
            />
            <FieldInput
              fieldId={'floorCount'}
              label={'מספר קומות'}
              containerCustomStyles={styles.quarterField}
            />
            <FieldInput
              fieldId={'buildingAge'}
              onChange={limitIntegerValueLength(4)}
              label={'שנת בניה'}
              containerCustomStyles={styles.quarterField}
            />
          </div>
        </div>
        <div className={styles.unit}>
          <div className={styles.subheader}>מידע נוסף</div>
          <div className={classnames(styles.flexBetween, styles.threeQuartersRow)}>
            <FieldCheckbox
              fieldId={'elevator'}
              label={'מעלית'}
              containerStyles={styles.fitContent}
            />
            <FieldCheckbox
              fieldId={'parking'}
              label={'חניה'}
              containerStyles={styles.fitContent}
            />
            <FieldCheckbox
              fieldId={'yard'}
              label={'חצר'}
              containerStyles={styles.fitContent}
            />
            <FieldCheckbox
              fieldId={'storage'}
              label={'מחסן'}
              containerStyles={styles.fitContent}
            />
            <FieldCheckbox
              fieldId={'roof'}
              label={'גג'}
              containerStyles={styles.fitContent}
            />
          </div>
        </div>
        <div className={styles.unit}>
          <div className={styles.subheader}>קבצים</div>
          <InspectionOtherFilesProvider>
            <SectionFiles orderID={orderID} shumaID={shumaID}/>
          </InspectionOtherFilesProvider>
        </div>
        <div className={classnames(styles.unit, styles.borderBottomNone)}>
          <div className={styles.subheader}>מידע לקוחות</div>
          <FieldFindCustomers
            formik={formik}
            name={'customers'}
            readOnlyMode={true}
          />
        </div>
        <div className={classnames(styles.flexEnd, styles.marginBottom64)}>
          <ButtonCommon
            label={'שמור'}
            onClick={() => {
              handleDataSubmit(formik.values)
            }}
            customContainerStyles={styles.buttonSubmit}
          />
        </div>
      </Form>
    </div>
  );
};


InspectionOtherFormView.propTypes = {
  list: PropTypes.array,
};

export default InspectionOtherFormView;

